import React, { useEffect, useMemo, useState, } from 'react';
import { Dimensions, Platform, ScrollView, StyleSheet, TouchableOpacity, View, } from 'react-native';
import { ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { ModalAlignmentEnum, } from '@voltmoney/types';
import { isMobile } from '../../stack/utils';
import { getScreenType } from '../bankSelectPage/BankSelect';
import { Typography } from '../../typography/Typography';
import { Icon } from '../../icon/Icon';
import { Button } from '../../button/Button';
import { isIos, } from '../utils';
import { hasOnlyDescriptionAndValue, hasPropertySubText, } from '../kfsPage/utils';
import Accordion from '../component/accordian/accordian';
import AccordionItem from '../component/accordian/accordianItem';
import { Row, Table, } from 'react-native-table-component';
import CustomHeader from '../../customHeader/CustomHeader';
import BottomSheet from '../BottomSheet';
import LottieView from 'lottie-react-native';
import WebView from "react-native-webview";
const BajajKFS = ({ height, goBack, getEmailStatementAction, emailStatementButtonLoading = false, agreeAction, kfs_data, lenderData, needHelp, showSuccess, triggerAction, counter, successCardAction, showLoading, }) => {
    const [_lenderData, setLenderData] = useState(lenderData);
    const [_loading, setLoading] = useState(false);
    const [kfsData, setKfsData] = useState(kfs_data.kfsDetails);
    const [kfsParameters, setKfsParameters] = useState(kfs_data?.kfsParameters);
    const [repaymentSchedules, setRepaymentSchedules] = useState(kfs_data?.repaymentSchedules);
    const [repaymentScheduleTable, setRepaymentScheduleTable,] = useState(kfs_data.repaymentSchedules);
    const [agreeSelected, setAgreeSelected] = useState(false);
    const [showSuccessCard, setShowSuccessCard] = useState(false);
    const interestDuePerMonth = (_lenderData.lenderBusinessDetails
        .annualizedInterestRate /
        100) *
        10000;
    const [successLottie, setSuccessLottie] = useState('');
    const [iLottieFetched, setLottieFetched] = useState(false);
    const [disagreeSelected, setDisagreeSelected] = useState(false);
    const [warningCard, setWarningCard] = useState(false);
    const [isButtonLoading, setButtonLoading] = useState(false);
    useEffect(() => {
        setLoading(emailStatementButtonLoading);
    }, [emailStatementButtonLoading]);
    useEffect(() => {
        setShowSuccessCard(showSuccess);
    }, [showSuccess, counter]);
    useEffect(() => {
        if (!showLoading)
            setButtonLoading(false);
    }, [showLoading]);
    const successJsonLottie = 'https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json';
    useEffect(() => {
        fetch(successJsonLottie, {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((responseData) => {
            setSuccessLottie(responseData);
            setLottieFetched(true);
        })
            .catch((error) => {
            console.log(error);
        });
    }, []);
    const renderWarningCard = () => {
        return (React.createElement(View, { style: {
                flexDirection: 'column',
                alignContent: 'center',
                alignSelf: 'center',
                alignItems: 'center',
                padding: 16,
                marginTop: 24,
                width: '100%'
            } },
            React.createElement(Icon, { name: IconTokens.SystemWarning, size: IconSizeTokens.XXXXXXL }),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4B, label: 'You must agree with key terms to\nproceed with application', textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: {
                    borderRadius: 8,
                    backgroundColor: '#F1F3F5',
                    height: 64,
                    padding: 10,
                    justifyContent: 'center',
                    alignContent: 'center',
                    marginTop: 8,
                } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Please contact our support team if you have any questions about terms and charges', textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginTop: 24, width: '100%' } },
                React.createElement(Button, { id: 'bt_bajajKFS_goBack', type: ButtonTypeTokens.LargeFilled, label: 'Go back', fontSize: FontSizeTokens.SM, width: ButtonWidthTypeToken.FULL, onPress: () => {
                        setWarningCard(false);
                    } }),
                React.createElement(View, { style: { width: '100%', marginTop: 16 } },
                    React.createElement(Button, { id: 'bt_bajajKFS_contactSupport', type: ButtonTypeTokens.LargeSoftFilled, label: 'Contact support', fontSize: FontSizeTokens.SM, width: ButtonWidthTypeToken.FULL, onPress: () => {
                            setWarningCard(false);
                            triggerAction(needHelp);
                        } })))));
    };
    const renderSuccessCard = () => {
        return (React.createElement(View, { style: {
                padding: 16,
                width: '100%',
                alignContent: 'center',
                alignSelf: 'center',
                alignItems: 'center',
                height: 210,
                position: 'absolute',
                bottom: 0,
            } },
            Platform.OS === 'ios'
                && React.createElement(LottieView, { source: { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" }, style: { width: 80, height: 80 }, autoPlay: true, loop: true }),
            Platform.OS !== 'ios'
                && successLottie !== ""
                && React.createElement(LottieView, { source: successLottie, style: styles.successLottie, autoPlay: true, loop: true }),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'Key terms accepted!' })),
            React.createElement(View, { style: { marginTop: 4, marginBottom: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: ' You will be redirected to next step in few seconds' })),
            React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, label: 'Continue', onPress: () => {
                    if (successCardAction) {
                        triggerAction(successCardAction);
                    }
                } })));
    };
    const kycStatusCard = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: showSuccessCard ? 210 : 380, width: '100%', closeFunction: () => {
                    setShowSuccessCard(false);
                    setWarningCard(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: showSuccessCard ? false : true, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 508, routeId: 'routeId', handleKeyboard: true }, iLottieFetched && showSuccessCard
                ? renderSuccessCard()
                : renderWarningCard())));
    };
    const _headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: 'Key fact statement', goBackAction: goBack, needHelpAction: needHelp, goBackId: 'bt_BajajKFS_goBack', needHelpId: 'bt_BajajKFS_needHelp', triggerAction: triggerAction }));
    }, []);
    const renderInterestRepaymentTable = () => {
        let firstData = repaymentScheduleTable[0];
        const flexArr = [5, 5];
        const dataRows = [
            [
                'Opening principal ****',
                `₹${firstData?.openingPrinciple}`,
            ],
            [
                'Installment amount',
                `₹${firstData?.installmentAmount}`,
            ],
            ['Principal', `₹${firstData?.principle}`],
            [
                'Interest',
                `₹${firstData?.interest}`,
            ],
            [
                'Closing principal',
                `₹${firstData?.closingPrinciple}`,
            ],
            // Add more rows as needed
        ];
        return (React.createElement(View, null,
            React.createElement(ScrollView, { style: styles.tableDataWrapper },
                React.createElement(Table, { borderStyle: {
                        borderColor: '#E4E7EC',
                        borderWidth: 1,
                    } }, dataRows.map((rowData, index) => (React.createElement(Row, { key: index, data: rowData, flexArr: flexArr, style: [
                        styles.tableRow,
                        {
                            backgroundColor: '#ffffff',
                        },
                    ], textStyle: styles.tableText })))))));
    };
    const renderPrincipalRepaymentTable = () => {
        let size = repaymentScheduleTable.length;
        let firstData = repaymentScheduleTable[0];
        let lastData = repaymentScheduleTable[size - 1];
        const flexArr = [5, 5];
        const dataRows = [
            [
                'Opening principal ****',
                `₹${lastData?.openingPrinciple}`,
            ],
            [
                'Installment amount',
                `₹${lastData?.installmentAmount}`,
            ],
            ['Principal', `₹${lastData?.principle}`],
            ['Interest', `₹${lastData?.interest}`],
            [
                'Closing principal',
                `₹${lastData?.closingPrinciple}`,
            ],
            // Add more rows as needed
        ];
        return (React.createElement(View, null,
            React.createElement(ScrollView, { style: styles.tableDataWrapper },
                React.createElement(Table, { borderStyle: {
                        borderColor: '#E4E7EC',
                        borderWidth: 1,
                    } }, dataRows.map((rowData, index) => (React.createElement(Row, { key: index, data: rowData, flexArr: flexArr, style: [
                        styles.tableRow,
                        {
                            backgroundColor: '#ffffff',
                        },
                    ], textStyle: styles.tableText })))))));
    };
    const renderRepaymentCalculationCard = () => {
        const repaymentCardItems = [
            {
                title: 'Withdrawal Amount:',
                value: '₹10,000',
            },
            {
                title: 'Interest Rate',
                value: `${(_lenderData.lenderBusinessDetails
                    .annualizedInterestRate / 12).toFixed(2)}% per month ( @${lenderData.lenderBusinessDetails
                    .annualizedInterestRate}% per year)`,
            },
            {
                title: 'Interest due (based on withdrawal amount)',
                value: `₹${(interestDuePerMonth / 12).toFixed(2)} per month`,
            },
            {
                title: 'Principal repayment',
                value: 'Repay principal amount anytime',
            },
        ];
        return (React.createElement(View, { style: {
                padding: 12,
            } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: '* APR is calculated based on the net loan amount. Net loan amount is calculated after deducting charges like processing fee, inclusive of GST.\n\n' }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: '** If any DP charges are applicable(as levied by NSDL / CDSL), they will be passed on to the client.\n\n' }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: '*** If any charges are applicable and applied by the broker, they will be passed on to the client.\n\n' }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: '****If full credit limit is withdrawn\n\n' }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Note: BFL offers an option to exit the loan within the Cooling Off/Look-Up period by repaying the principal amount without incurring any penalties.\n\n' })));
    };
    const detailRepaymentScheduleCard = (React.createElement(View, { style: {
            paddingTop: 16,
        } },
        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Total installments' }),
        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: `${repaymentScheduleTable.length}` }),
        React.createElement(View, { style: { marginTop: 16 } },
            React.createElement(Typography, { label: `Installments from 1st month to ${repaymentScheduleTable.length - 1}th month(if only interest is paid)`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '500', lineHeight: 20 }),
            React.createElement(View, { style: { height: 8 } }),
            renderInterestRepaymentTable(),
            React.createElement(View, { style: { height: 16 } }),
            React.createElement(Typography, { label: `Installment for ${repaymentScheduleTable.length}th Month(Last installment)`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '500', lineHeight: 20 }),
            React.createElement(View, { style: { height: 8 } }),
            renderPrincipalRepaymentTable(),
            React.createElement(View, { style: { height: 24 } }),
            renderRepaymentCalculationCard())));
    const renderFactItem = (_renderItem) => {
        const renderItems = [];
        const generateFactItem = (item) => {
            if (typeof item !== 'object') {
                return null;
            }
            if (typeof item === 'object' &&
                !hasOnlyDescriptionAndValue(item)) {
                renderItems.push({
                    ...item,
                    isSubtitle: true,
                });
                Object.keys(item).map((key, index) => {
                    return React.createElement(React.Fragment, null, generateFactItem(item[key]));
                });
            }
            if (typeof item === 'object' &&
                hasPropertySubText(item)) {
                renderItems.push({
                    ...item,
                    isSubtext: true,
                });
            }
            hasOnlyDescriptionAndValue(item) &&
                renderItems.push(item);
        };
        generateFactItem(_renderItem);
        return (renderItems &&
            renderItems.map((data, index) => {
                if (data?.isSubtitle && data?.description) {
                    return (React.createElement(View, { style: {
                            paddingTop: 8,
                            paddingBottom: 8,
                        } },
                        React.createElement(Typography, { label: `${data?.description}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '700', lineHeight: 20 })));
                }
                else if (data?.isSubtext && data?.subText) {
                    return (React.createElement(View, { style: {
                            paddingTop: 8,
                            paddingBottom: 8,
                        } },
                        React.createElement(Typography, { label: `${data?.subText}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20 })));
                }
                return ((data?.description || data?.value) && (React.createElement(React.Fragment, null,
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            paddingTop: 8,
                            paddingBottom: 8,
                        } },
                        React.createElement(Typography, { label: `${data?.description}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20 }),
                        React.createElement(Typography, { label: `${data?.value && data?.value !== ''
                                ? data?.value
                                : 'N/A'}`, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20 })))));
            }));
    };
    const renderRepaymentDate = () => {
        let tempData = '';
        repaymentSchedules.map((item, key) => {
            if (item) {
                const tableRowString = `<tr>
						<td>${item.installmentNumber}</td>
						<td>₹${item.openingPrinciple}</td>
						<td>₹${item.installmentAmount}</td>
						<td>₹${item.principle}</td>
						<td>₹${item.interest}</td>
						<td>₹${item.closingPrinciple}</td>
					</tr>`;
                tempData = tempData + tableRowString;
            }
        });
        return tempData;
    };
    const kfsDetailCard = (React.createElement(View, { style: {
            width: '100%',
            backgroundColor: '#FFF',
            paddingHorizontal: 16,
            paddingTop: 16,
        } },
        React.createElement(Typography, { label: `List of parameters`, fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24 }),
        React.createElement(Accordion, null,
            kfsData &&
                Object.keys(kfsData).map((key, index) => {
                    const { description, ...rest } = kfsData[key];
                    return (React.createElement(AccordionItem, { id: `acd_setCreditLimit_${index + 1}`, title: `${kfsData[key]?.description}`, showDivider: true }, key !== 'OTHER_DISCLOSURE_DETAILS' ? (React.createElement(React.Fragment, null,
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'column',
                                paddingTop: 8,
                            } }, renderFactItem({ ...rest })))) : (React.createElement(React.Fragment, null))));
                }),
            React.createElement(AccordionItem, { id: `acd_setCreditLimit_detailRepaymentScheduleCard`, title: 'Detailed repayment schedule', showDivider: false }, detailRepaymentScheduleCard))));
    const KFS_WebView_New = () => {
        return (React.createElement(WebView
        // @ts-ignore
        , { 
            // @ts-ignore
            style: {
                width: '100%',
                height: height - 170,
            }, source: {
                html: `
        			<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="utf-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Key Fact Statement</title>

    <link href="https://docapp.bajajfinserv.in/DocumentPOD_Lib/UI_Resource/Agreement/css/bootstrap.min.css"
          rel="stylesheet" />
    <link href="https://docapp.bajajfinserv.in/DocumentPOD_Lib/UI_Resource/Agreement/css/Custom.css" rel="stylesheet" />
    <style type="text/css">
        /* Print CSS */
        @media print {
            * {
                font-size: 13px !important;
            }

            html,
            body {
                margin: 0 !important;
                padding: 0 !important;
            }

            .print-clear {
                clear: both;
                float: left;
                width: 100%;
            }

            .page-title h1 {
                margin-bottom: 20px !important;
                font-size: 22px !important;
            }

            .box-wrapper {
                margin-top: 10px !important;
                padding: 10px !important;
            }

            .box-wrapper .box-head {
                margin: -10px -10px 10px -10px !important;
                padding: 10px !important;
            }

            .box-wrapper .box-body .box-label,
            .box-wrapper .box-body .box-value {
                margin-bottom: 10px !important;
            }

            .print-photo img {
                width: auto !important;
                height: auto !important;
                max-height: 100px !important;
            }

            .print-photo .img-barcode {
                margin-top: 40px !important;
            }

            .nav.mb-30 {
                margin-bottom: 15px !important;
            }

            .accept {
                padding: 10px !important;
            }

            .print-photo .col-sm-10 {
                width: 83.33333333%;
                float: left;
            }

            .print-photo .col-sm-2 {
                width: 16.66666667%;
                float: left;
            }

            .pagebreak {
                page-break-before: always;
            }

            tr {
                page-break-inside: auto
            }

            .table-sanction {
                float: none !important;
                page-break-before: avoid
            }

            .box-general-terms * {
                font-size: 12px !important;
            }

            .box-fees-charges .txt-big {
                font-size: 20px !important;
            }

            .plaMainHead {
                font-size: 22px !important;
                margin: 0 0 20px !important;
            }

            .regPera {
                margin-bottom: 10px !important;
            }

            .regPera {
                margin-bottom: 10px !important;
            }

            .headBox {
                font-size: 18px !important;
                padding: 0 !important;
                margin: 10px 0 20px !important;
            }

            .schSubBox1 {
                padding-bottom: 0 !important;
            }

            .schHeadSub,
            .schAnsTxt,
            .detHeadSub,
            .detAnsTxt,
            .ldmHeadSub1,
            .ldmAnsTxt1 {
                margin-bottom: 10px !important;
            }

            .schedHeadSub,
            .schedAnsTxt,
            .ldmHeadSub,
            .ldmAnsTxt {
                min-height: auto !important;
                margin-bottom: 10px !important;
            }

            .main-table tbody th,
            .main-table1 tbody th {
                font-family: DaxOT-Med !important;
                font-weight: normal !important;
            }

            .charPeraTxt {
                margin-bottom: 0 !important;
            }

            .bodFull {
                display: none !important;
            }

            .box-general-terms * {
                font-size: 12px !important;
            }

            .ktcBox,
            .ktcBoxHead,
            .ktcBoxPera {
                float: none !important;
            }

            .txt-big {
                font-size: 20px !important;
            }

            .oneform,
            .titlediv-new,
            .TitleAnsPart {
                float: none !important;
            }
        }

        /* Close - Print CSS */

        .mt-10 {
            margin-top: 10px !important;
        }

        .mt-20 {
            margin-top: 20px !important;
        }

        .mt-40 {
            margin-top: 40px !important;
        }

        .mr-10 {
            margin-right: 10px !important;
        }

        .mr-50 {
            margin-right: 50px !important;
        }

        .mr-100 {
            margin-right: 100px !important;
        }

        .mb-0 {
            margin-bottom: 0 !important;
        }

        .mb-5 {
            margin-bottom: 5px !important;
        }

        .mb-10 {
            margin-bottom: 10px !important;
        }

        .mb-20 {
            margin-bottom: 20px !important;
        }

        .mb-30 {
            margin-bottom: 30px !important;
        }

        .mb-50 {
            margin-bottom: 50px !important;
        }

        .pl-10 {
            padding-left: 10px !important;
        }

        ol li {
            margin-bottom: 5px;
        }

        .form-control-bdr {
            border-width: 0 0 1px 0;
            border-color: #000;
        }

        .header {
            padding: 20px 0;
            display: none;
        }

        .header-agreement {
            display: block;
        }

        .table-header tr td {
            vertical-align: middle !important;
            border: none !important;
            padding: 0 !important;
        }

        .page-title h1 {
            font-family: DaxOT-Bold;
            font-weight: normal;
            font-size: 30px;
            color: #448aff;
            margin-bottom: 30px;
        }

        .page-title h2 {
            font-family: DaxOT-Med;
            font-weight: normal;
            font-size: 20px;
            color: #000;
            margin-bottom: 30px;
        }

        h4 {
            font-family: DaxOT-Med;
            font-weight: normal;
            font-size: 16px;
            color: #337ab7;
        }

        .box-wrapper {
            border: solid 1px #d6d6d6;
            border-radius: 5px;
            padding: 20px;
            margin-top: 20px;
        }

        .box-wrapper .box-head {
            background: #EEE;
            border-bottom: solid 1px #d6d6d6;
            border-radius: 5px 5px 0 0;
            padding: 15px 20px;
            margin: -20px -20px 20px -20px;
            font-family: DaxOT-Bold;
            font-size: 16px;
            color: #000;
            text-transform: uppercase;
        }

        .box-wrapper .box-body .box {
            width: 100%;
            clear: both;
        }

        .box-wrapper .box-body .box-label,
        .box-wrapper .box-body .box-value {
            margin-bottom: 15px;
        }

        .box-wrapper .box-body .box-label {
            width: 230px;
            float: left;
            font-family: DaxOT-Med;
            position: relative;
            z-index: 1;
        }

        .box-wrapper .box-body .box-value {
            padding-left: 240px;
            position: relative;
        }

        .box-wrapper .box-body .box-value::before {
            content: ':';
            display: block;
            position: absolute;
            left: 230px;
            top: 0;
            color: #2b2b2b;
        }

        .box-wrapper .box-body .table {
            margin-bottom: 5px;
        }

        .box-wrapper .box-body .table>thead>tr>th {
            background: #eee;
            vertical-align: middle;
        }

        .accept {
            padding: 20px 30px;
        }

        .close {
            color: #aaaaaa;
            float: right;
            font-size: 28px;
            font-weight: bold;
        }

        .close:hover,
        .close:focus {
            color: #000;
            text-decoration: none;
            cursor: pointer;
        }

        .close2 {
            color: #aaaaaa;
            float: right;
            font-size: 28px;
            font-weight: bold;
        }

        .close2:hover,
        .close2:focus {
            color: #000;
            text-decoration: none;
            cursor: pointer;
        }

        .btnAccept {
            width: 126px;
            display: inline-block;
            background-color: #448aff;
            border-radius: 5px;
            padding: 5px;
            text-align: center;
            color: #FFF;
            font-size: 16px;
            font-family: DaxOT-Med;
        }

        .btnAccept:active,
        .btnAccept:hover,
        .btnAccept:focus {
            color: #FFF;
            text-decoration: none;
        }

        .btnDecline:active,
        .btnDecline:hover,
        .btnDecline:focus {
            color: #FFF;
            text-decoration: none;
        }

        .btnnew1 {
            background-color: #448aff;
            border-radius: 5px;
            padding: 5px;
            text-align: center;
            color: #FFF;
            font-size: 16px;
            font-family: DaxOT-Med;
        }

        .table-sanction {
            border: solid 1px #ddd;
            float: left;
            width: 100%;
            position: relative;
            margin-bottom: 20px;
        }

        .table-sanction::after {
            content: '';
            display: block;
            width: 1px;
            height: 100%;
            background: #ddd;
            position: absolute;
            left: 25%;
            top: 0;
        }

        .table-sanction .table-sanction-row {
            float: left;
            width: 100%;
            overflow: hidden;
            border-bottom: solid 1px #ddd;
        }

        .table-sanction .table-sanction-row .table-sanction-label,
        .table-sanction .table-sanction-row .table-sanction-value {
            padding: 10px 20px;
        }

        .table-sanction .table-sanction-row .table-sanction-label {
            float: left;
            width: 25%;
        }

        .table-sanction .table-sanction-row .table-sanction-value {
            float: left;
            width: 75%;
        }

        /* Deductions from Loan Amount */
        .box-wrapper .box-body .deductions-from-loan-amount .box-label {
            width: 180px;
        }

        .box-wrapper .box-body .deductions-from-loan-amount .box-value {
            padding-left: 190px;
        }

        .box-wrapper .box-body .deductions-from-loan-amount .box-value::before {
            left: 180px;
        }

        /* Fees & Charges */
        .box-fees-charges .txt-big {
            font-size: 22px;
        }

        .box-fees-charges .box-body {
            padding: 0 20px;
        }

        .box-fees-charges .fees-charges-list h6 {
            margin: 0 0 10px;
            padding: 0 0 10px;
            border-bottom: solid 1px #d6d6d6;
            font-family: DaxOT-Bold;
            font-size: 16px;
            color: #2b2b2b;
        }

        .box-fees-charges .fees-charges-list h6.sub-title {
            padding: 0;
            border-bottom: none;
        }

        .form-control-bdr {
            border-width: 0 0 1px 0;
            border-color: #000;
            background-color: #FFFFFF;
        }

        .table>thead>tr>th {
            background: #eee;
            vertical-align: middle;
        }

        .titlediv-new {
            float: left;
            width: 100%;
            padding: 4px 20px;
            border-radius: 5px;
        }

        .titlediv-new>h4 {
            font-size: 16px;
            font-family: DaxOT-Bold;
            color: #000;
            float: none !important;
        }

        .TitleAnsPart {
            display: block !important;
        }

        .schHeadSub {
            width: 60%;
        }

        .schAnsTxt {
            width: 40%;
        }

        .schedHeadSub,
        .schedAnsTxt,
        .ldmHeadSub,
        .ldmAnsTxt {
            min-height: inherit;
        }

        .page-title h1 {
            font-family: DaxOT-Bold;
            font-weight: normal;
            font-size: 30px;
            color: #448aff;
            margin-bottom: 30px;
        }

        .form-control-bdr {
            border-width: 0 0 1px 0;
            border-color: #000;
            background-color: #FFFFFF
        }

        .txt-big {
            font-size: 22px;
        }

        .loan-table tr th {
            font-style: normal;
        }

        .loan-table tr td {
        < !-- font-style: italic;
        -->
        }

        @media screen and (min-width:768px) and (max-width:991px) {
            section>.container {
                padding-left: 0;
                padding-right: 0;
                width: 720px;
            }
        }

        @media screen and (max-width:768px) {
            .modal-content {
                width: 70%;
            }
        }

        @media screen and (max-width:767px) {
            .header {
                display: block;
            }

            .table-header tr td {
                display: block;
                float: left;
                width: 100%;
                text-align: left;
            }

            .table-header tr td.text-right {
                display: none;
            }

            .page-title h1 {
                font-size: 24px;
                margin-bottom: 30px;
            }

            .box-wrapper .box-body .box-label {
                width: auto;
                float: none;
                margin-bottom: 5px;
            }

            .box-wrapper .box-body .box-value {
                padding-left: 0;
            }

            .box-wrapper .box-body .box-value::before {
                display: none;
            }

            /* Deductions from Loan Amount */
            .box-wrapper .box-body .deductions-from-loan-amount .box-label {
                width: auto;
            }

            .box-wrapper .box-body .deductions-from-loan-amount .box-value {
                padding-left: 0;
            }

            .box-wrapper .box-body .deductions-from-loan-amount .box-value::before {
                left: 0;
            }

            .row-btn div {
                text-align: center !important;
                margin-bottom: 30px;
            }

            .table-sanction::after {
                display: none;
            }

            .table-sanction .table-sanction-row {
                border-bottom: solid 1px #ddd;
            }

            .table-sanction .table-sanction-row .table-sanction-label {
                font-family: DaxOT-Med;
            }

            .table-sanction .table-sanction-row .table-sanction-label,
            .table-sanction .table-sanction-row .table-sanction-value {
                float: none;
                width: 100%;
                padding: 10px 20px;
            }

            .table-sanction .table-sanction-row .table-sanction-value {
                padding-top: 0;
            }

            section>.container {
                padding-left: 0;
                padding-right: 0;
            }
        }

        @media screen and (max-width: 600px) {
            .schAnsTxt {
                width: 100% !important;
            }

            .schHeadSub {
                width: 100% !important;
            }
        }

        /* @media print {
          KeyFactStatement {page-break-after: always;}
        } */

        .page-break {
            page-break-after: always;
        }

        .page-break-2 {
            page-break-after: always;
        }

        @media print {
            a[href]:after {
                content: none !important;
            }
        }
    </style>
</head>

<body>
<div class="container pagebreak">
    <div class="header header-agreement text-right">
        <a href="#"><img src="https://docapp.bajajfinserv.in/DocumentPOD_Lib/UI_Resource/Agreement/images/logo.png"
                         alt="" /></a>
    </div>
    <div class="page-title">
        <h1 class="text-center" style="color: #448aff !important;">BAJAJ FINANCE LIMITED ("BFL") - Key Fact Statement</h1>
    </div>

    <div class="box-wrapper">
        <div class="box-body">

            <p style="margin:0px;padding:10px 0px 5px 0px;">Date: ${kfsParameters.Date_SAN}</p>
            <p style="margin:0px;padding:10px 0px 5px 0px;">Reference No. :  ${kfsParameters.RefNO_SAN}</p>
            <p style="margin:0px;padding:10px 0px 5px 0px;">Customer Name : ${kfsParameters.Cust_Name}</p>
            <br>
            <p style="margin:0px;padding:10px 0px 5px 0px;">Subject : Key Fact Statement</p>
            <br>
            <p style="margin:0px;padding:10px 0px 5px 0px;">Dear ${kfsParameters.Cust_Name},</p>
            <p style="margin:0px;padding:10px 0px 5px 0px;">We thank you for choosing Bajaj Finance Limited <b>(“BFL”)</b>
                as your financial partner and look forward to an enduring relationship with you.</p>


            <p style="margin:0px;padding:10px 0px 5px 0px;">With reference to your loan application, we are pleased to
                extend to you a
                <b>${kfsParameters.Loan_Type}.</b> As you embark on this journey with us, our priority is to ensure that you are well-informed
                about the
                Total interest payable for entire tenure of the loan, fees &amp; and charges, Annual percentage Rate (APR),
                and other important terms including Repayment Terms associated with this loan, all of which are detailed in
                the following
                "Key Fact Statement"
                <br>
            <p style="margin:0px;padding:10px 0px 5px 0px;">Please note all details given in respective sections.Your
                acceptance of this Key Fact Statement by clicking on "I Agree" and/or providing your physical signature will
                constitute a valid acceptance of the “Key Fact Statement” contained therein and same shall have binding effect
                on you.</p>
            <p style="margin:0px;padding:10px 0px 5px 0px;">Thanking You, </p>

            <img src="https://emandate-staging.bajajfinserv.in/DocumentPOD_Lib/UI_Resource/Agreement/images/manish.png" />

            <p style="margin:0px;padding:20px 0px 0px 0px;"> Authorised Signatory, </p>
            <p style="margin:0px;padding:20px 0px 5px 0px;"><strong>Bajaj Finance Ltd.</strong></p>
            <br>

            <!-- <p class="mb-20">With reference to your loan application, we are pleased to extend to you a Personal Loan for an -->
            <!-- amount detailed below subject to terms and conditions set out in this letter (“<strong> Key Fact Statement -->
            <!-- </strong>”) and execution of the loan documents between you, i.e. the “<strong>Borrower</strong>” and -->
            <!-- BFL and submission of other required documents detailed below.</p> -->

            <div class="page-break">

            </div>


            <tr id="KeyFactStatement" class="page-break">
                <td style="padding:8px;">
                    <!--[if (gte mso 9)|(IE)]><table width="600" align="center" bgcolor="#f0f4ff"><tr><td align="center"><![endif]-->
                    <table width="100%" cellpadding="0" cellspacing="0" border="0" align="center"
                           style="font-family: Arial;  color:#444444;text-align:left; background:#ffffff;background-image: url('images/bg.png');background-repeat: no-repeat;">


                        <tr>
                            <td height="8"></td>
                        </tr>
                        <tr>
                            <td style="padding:12px 0px 12px 0px;">
                                <p style="font-size: 18px;text-align: center;font-family: Arial;">
                                    <strong style="font-size: 22px;font-family: arial;">Key Fact Statement</strong>

                            </td>
                        </tr>

                        <tr>
                            <td height="8">
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <table width="100%" cellpadding="0" cellspacing="0" style="background: #FFFFFF;" class="loan-table">

                                    <tr>
                                        <td>
                                            <table width="100%" cellpadding="0" cellspacing="0" style="background: #FFFFFF;">
                                                <tr>
                                                    <td>
                                                        <table width="100%" cellpadding="0" cellspacing="0"
                                                               style="border-collapse: collapse;border-bottom: 1px solid #979797;">
                                                            <thead>
                                                            <th bgcolor="#002953" width="10%"
                                                                style="border:1px solid #979797;padding:5px 5px;font-size:13px;line-height: 15px;letter-spacing: 0.0888889px;color: #fff;text-align: center;">
                                                                Sr No</th>
                                                            <th bgcolor="#002953" width="60%"
                                                                style="border:1px solid #979797;padding:5px 5px;font-size: 13px;line-height: 15px;letter-spacing: 0.0888889px;color: #fff;text-align: center;">
                                                                Parameter</th>
                                                            <th bgcolor="#002953" width="30%"
                                                                style="border:1px solid #979797;padding:5px 5px;font-size: 13px;line-height: 15px;letter-spacing: 0.0888889px;color: #fff;text-align: center;">
                                                                Details</th>
                                                            </thead>

                                                            <tbody>
                                                            <tr>
                                                                <td align="middle" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;">
                                                                    1
                                                                </td>
                                                                <td valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: Arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000; vertical-align: middle">
                                                                    Loan Amount
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    ${kfsParameters.DISBURSEDAMOUNT}

                                                                </td>
                                                            </tr>

                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">
                                                                    2
                                                                </td>
                                                                <td valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    Annualized Rate of Interest
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    ${kfsParameters.AnnualInterestRate_KFS} (Floating Interest Rate)
                                                                    <!-- P. A. (RBI repo rate +Spread), Interest to be paid monthly.</p> -->
                                                                    <!-- <p>Currently, RBI repo rate: ##Benchmark##%.</p> -->
                                                                    <!-- <p>Spread: ##Spread##%</p> -->
                                                                    <!-- <p>Subject to BFL’s right to revise Interest rate and Spread</p> -->
                                                                    <!-- </td> -->



                                                            </tr>
                                                            </tbody>

                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;">
                                                                    3
                                                                </td>
                                                                <td valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle">
                                                                    Total interest charge during the entire tenure of the loan<sup>(1)</sup>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle">
                                                                    ${kfsParameters.TOTAL_INT_AMT}
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important">
                                                                    4
                                                                </td>
                                                                <td valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    Upfront charges borne by customer (break-up of each component given below)
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    ${kfsParameters.Processingfees}
                                                                </td>




                                                            </tr>
                                                            </tbody>




                                                            <tbody>
                                                            <tr id='DeductionsList' style='display: none;'></tr>
                                                            </tbody>


                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important">

                                                                </td>
                                                                <td valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 20px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <em> Processing Fees </em>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <i>${kfsParameters.Processingfees}</i>
                                                                </td>



                                                            </tr>
                                                            </tbody>


                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important">
                                                                    5
                                                                </td>
                                                                <td valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    Net loan amount for APR (No 1)-(No 4)<sup>(1)</sup>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    ${kfsParameters.AmountRow44}
                                                                </td>



                                                            </tr>
                                                            </tbody>

                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important">
                                                                    6
                                                                </td>
                                                                <td valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    Total Amount to be paid by borrower towards loan (No 1)+(No 3)+(No
                                                                    4)<sup>(1)</sup>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    ${kfsParameters.AmountRow55}
                                                                </td>



                                                            </tr>
                                                            </tbody>


                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important">
                                                                    7
                                                                </td>
                                                                <td valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    Annual Percentage Rate - Effective annualized interest rate (in percentage)
                                                                    (computed on net loan amount (No. 5) using IRR approach and reducing balance
                                                                    method) (%)<sup>(1)</sup>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    ${kfsParameters.APR_RATE}
                                                                </td>



                                                            </tr>
                                                            </tbody>



                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important">
                                                                    8
                                                                </td>
                                                                <td valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    Optional value added products/services opted by the borrower (Not part of APR)
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    ${kfsParameters.AmountRow8}
                                                                </td>
                                                                <!-- <td ##KFS_8Pt##
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">

                                                                  </td> -->


                                                            </tr>
                                                            </tbody>



                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important">
                                                                    9
                                                                </td>
                                                                <td valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    Net disbursement amount after deduction of Optional value added product/services
                                                                    amount (No 5) - (No 8)
                                                                    <sup>(1)</sup>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    ${kfsParameters.AmountRow66}
                                                                </td>



                                                            </tr>
                                                            </tbody>


                                                            <!-- <tbody>
                                                              <tr>
                                                                <td  align="top"
                                                                  style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important">
                                                                  8
                                                                </td>
                                                                <td
                                                                  style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                  Total Amount to be paid by borrower [1+2+3+5]
                                                                </td>
                                                                <td ##KFS_4Pt##
                                                                  style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                  ##AmountRow7##
                                                                </td>



                                                              </tr>
                                                            </tbody> -->



                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;">
                                                                    10
                                                                </td>
                                                                <td valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 17px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle">
                                                                    Tenure of loan (in Months)
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle">
                                                                    ${kfsParameters.GROSS_LOAN_TENURE}
                                                                </td>
                                                            </tr>
                                                            </tbody>


                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;">
                                                                    11
                                                                </td>
                                                                <td valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 17px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle">
                                                                    Repayment frequency by the borrower
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle">
                                                                    Monthly
                                                                </td>
                                                            </tr>
                                                            </tbody>

                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">
                                                                    12
                                                                </td>
                                                                <td valign="middle">
                                                                    <p
                                                                            style="padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                        Number of instalments of repayment
                                                                    </p>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <!-- ##LoanTenure_Validation## -->
                                                                    ${kfsParameters.GROSS_LOAN_TENURE}
                                                                </td>
                                                            </tr>
                                                            </tbody>


                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;">
                                                                    13
                                                                </td>
                                                                <td
                                                                        style="border:1px solid #979797;padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 17px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle">

                                                                    Amount of each instalment of repayment
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle">
                                                                    ${kfsParameters.installment_amount}
                                                                </td>
                                                            </tr>

                                                            </tbody>





                                                            <!-- <tr id='InitLoanTenorCheck3'> -->
                                                            <!-- <td align="top" -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;border-top:none"> -->

                                                            <!-- </td> -->
                                                            <!-- <td -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->
                                                            <!-- For Hybrid Flexi loan -->
                                                            <!-- </td> -->
                                                            <!-- <td -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->

                                                            <!-- </td> -->
                                                            <!-- </tr> -->

                                                            <!-- <tbody id='InitLoanTenorCheck4'> -->
                                                            <!-- <tr> -->
                                                            <!-- <td align="top" -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;border-top:none;"> -->

                                                            <!-- </td> -->
                                                            <!-- <td -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 24px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->
                                                            <!-- - Initial Tenure -->
                                                            <!-- </td> -->
                                                            <!-- <td -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->
                                                            <!-- ##Instalment_amount## -->
                                                            <!-- </td> -->
                                                            <!-- </tr> -->

                                                            <!-- <tr> -->
                                                            <!-- <td align="top" -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-top:none;"> -->

                                                            <!-- </td> -->
                                                            <!-- <td -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 24px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->
                                                            <!-- - Subsequent Tenure -->
                                                            <!-- </td> -->
                                                            <!-- <td -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->
                                                            <!-- ##EMI_SUBSEQUENT_TENURE## -->
                                                            <!-- </td> -->
                                                            <!-- </tr> -->
                                                            <!-- </tbody> -->
                                                            <tbody>
                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;">
                                                                    14
                                                                </td>
                                                                <td
                                                                        style="border:1px solid #979797;padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 17px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle">
                                                                    <b>Details about Contingent Charges</b>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle">

                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 30px;font-family: arial;margin: 0 0 0px !important;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important">
                                                                    <!-- &#x2022;-->
                                                                </td>
                                                                <td>
                                                                    <p
                                                                            style="padding:8px 8px 0px 20px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;margin: 0 0 0px !important;vertical-align: middle;">
                                                                        <em> Part Pre-Payment Charges </em>
                                                                    </p>
                                                                    <p
                                                                            style="padding:2px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;margin: 0 0 0px !important;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                        <!-- % (Inclusive of applicable taxes) of the principal amount of loan prepaid on the -->
                                                                        <!-- date of such part pre-payment -->
                                                                        <!-- Part Pre-Payment Charges (Inclusive of GST) -->
                                                                    </p>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <i>
                                                                        ${kfsParameters.Part_Prepayment}
                                                                    </i>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 30px;margin: 0 0 0px !important;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important">

                                                                </td>
                                                                <td>
                                                                    <p
                                                                            style="padding:8px 8px 0px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;margin: 0 0 0px !important;color: #000000;vertical-align: middle;border-top: 1px solid #979797;">
                                                                        <!-- Full Pre-Payment Charges : -->
                                                                    </p>
                                                                    <p
                                                                            style="padding:2px 8px 8px 20px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;margin: 0 0 0px !important;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                        <!-- % (Inclusive of applicable taxes) of the outstanding loan amount as on the date -->
                                                                        <!-- of -->
                                                                        <!-- full pre-payment -->
                                                                        <em> Full Pre-Payment Charges (Foreclosure Charges) </em>
                                                                    </p>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <i>
                                                                        ${kfsParameters.Full_Prepayment}
                                                                    </i>

                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 30px;margin: 0 0 0px !important;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important">

                                                                </td>
                                                                <td>
                                                                    <p
                                                                            style="padding:8px 8px 0px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;margin: 0 0 0px !important;color: #000000;vertical-align: middle;border-top: 1px solid #979797;">
                                                                        <!-- Full Pre-Payment Charges : -->
                                                                    </p>
                                                                    <p
                                                                            style="padding:2px 8px 8px 20px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;margin: 0 0 0px !important;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                        <!-- % (Inclusive of applicable taxes) of the outstanding loan amount as on the date -->
                                                                        <!-- of -->
                                                                        <!-- full pre-payment -->
                                                                        <em> Annual Maintenance charges / Renewal Fees </em>
                                                                    </p>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <i>
                                                                        ${kfsParameters.AMC_Charges}
                                                                    </i>
                                                                </td>
                                                            </tr>

                                                            <!-- <tr> -->
                                                            <!-- <td align="top" -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;"> -->
                                                            <!-- b -->
                                                            <!-- </td> -->
                                                            <!-- <td> -->
                                                            <!-- <p -->
                                                            <!-- style="padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top:1px solid #979797;"> -->
                                                            <!-- Annual Maintenance charges -->
                                                            <!-- </p> -->
                                                            <!-- </td> -->
                                                            <!-- <td -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->

                                                            <!-- </td> -->
                                                            <!-- </tr> -->
                                                            <!-- <tr> -->
                                                            <!-- <td align="top" -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;;border-top:none;border-bottom: none;"> -->

                                                            <!-- </td> -->
                                                            <!-- <td> -->
                                                            <!-- <p -->
                                                            <!-- style="padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top: 1px solid #979797;"> -->
                                                            <!-- - Term Loan -->
                                                            <!-- </p> -->

                                                            <!-- </td> -->
                                                            <!-- <td -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->
                                                            <!-- NA -->
                                                            <!-- </td> -->
                                                            <!-- </tr> -->
                                                            <!-- <tr> -->
                                                            <!-- <td align="top" style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center; -->
                                                            <!-- border-bottom:none;border-top: none !important;"> -->

                                                            <!-- </td> -->
                                                            <!-- <td> -->
                                                            <!-- <p -->
                                                            <!-- style="padding:8px 8px 0px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top: 1px solid #979797;"> -->
                                                            <!-- - Flexi Term Loan (Flexi Dropline) -->
                                                            <!-- </p> -->
                                                            <!-- <p -->
                                                            <!-- style="padding:8px 8px 0px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->
                                                            <!-- (Inclusive of applicable taxes) of the Total Withdrawable Amount (as per the -->
                                                            <!-- repayment schedule) on the date of levy of such charges. -->
                                                            <!-- </p> -->

                                                            <!-- </td> -->
                                                            <!-- <td -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->
                                                            <!-- ##AMC_FLEXI_DROPLINE_LOAN -->
                                                            <!-- </td> -->
                                                            <!-- </tr> -->
                                                            <!-- <tr> -->
                                                            <!-- <td align="top" -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;;border-top:none !important;border-bottom: none !important;"> -->

                                                            <!-- </td> -->
                                                            <!-- <td> -->
                                                            <!-- <p -->
                                                            <!-- style="padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top: 1px solid #979797;"> -->
                                                            <!-- - Flexi Hybrid Loan -->
                                                            <!-- </p> -->

                                                            <!-- </td> -->
                                                            <!-- <td -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->

                                                            <!-- </td> -->
                                                            <!-- </tr> -->
                                                            <!-- <tr> -->
                                                            <!-- <td align="top" -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;;border-top:none !important;border-bottom: none !important;"> -->

                                                            <!-- </td> -->
                                                            <!-- <td> -->
                                                            <!-- <p -->
                                                            <!-- style="padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;line-height: 17px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top: 1px solid #979797;"> -->
                                                            <!-- <strong> i) Initial Tenure - </strong> (Inclusive of applicable taxes) of the -->
                                                            <!-- Total -->
                                                            <!-- Withdrawable Amount during Initial Tenure. -->
                                                            <!-- </p> -->

                                                            <!-- </td> -->
                                                            <!-- <td -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->
                                                            <!-- ##AMC_FLEXI_TERM_LOAN -->
                                                            <!-- </td> -->
                                                            <!-- </tr> -->
                                                            <!-- <tr> -->
                                                            <!-- <td align="top" -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;;border-top:none !important;border-bottom: none !important;"> -->

                                                            <!-- </td> -->
                                                            <!-- <td> -->
                                                            <!-- <p -->
                                                            <!-- style="padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;line-height: 17px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top: 1px solid #979797;"> -->
                                                            <!-- <strong> ii) Subsequent Tenure - </strong> - (Inclusive of applicable taxes) of -->
                                                            <!-- Total Withdrawable Amount during Subsequent Tenure. -->
                                                            <!-- </p> -->

                                                            <!-- </td> -->
                                                            <!-- <td -->
                                                            <!-- style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;"> -->
                                                            <!-- ##AMC_FLEXI_HYBRID_LOAN -->
                                                            <!-- </td> -->
                                                            <!-- </tr> -->

                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 30px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">

                                                                </td>
                                                                <td>
                                                                    <p
                                                                            style="padding:8px 8px 0px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top:1px solid #979797;">
                                                                        <!-- Bounce Charges - -->
                                                                    </p>
                                                                    <p
                                                                            style="padding:0px 8px 0px 20px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                        <em> Bounce Charges (for each default in repayment of instalment) </em>
                                                                    </p>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <i>
                                                                        ${kfsParameters.Bounce_Charges}
                                                                    </i>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 30px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">

                                                                </td>
                                                                <td>
                                                                    <p
                                                                            style="padding:15px 8px 0px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top:1px solid #979797;">
                                                                        <!-- Penal Interest - -->
                                                                    </p>
                                                                    <p
                                                                            style="padding:0px 8px 0px 20px;font-size: 12px;line-height: 14px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                        <em> Annualised Penal Interest for delay in payment of monthly instalments (if
                                                                            any) </em>
                                                                    </p>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <i>
                                                                        ${kfsParameters.Penal_Interest}
                                                                    </i>
                                                                </td>
                                                            </tr>





                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 30px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">

                                                                </td>
                                                                <td>
                                                                    <p
                                                                            style="padding:15px 8px 0px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top:1px solid #979797;">
                                                                    </p>
                                                                    <p
                                                                            style="padding:0px 0px 0px 20px;font-size: 12px;line-height: 14px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                        <em> Brokerage Charges </em>
                                                                    </p>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <i>As applicable at actuals</i>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 30px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">

                                                                </td>
                                                                <td>
                                                                    <p
                                                                            style="padding:15px 8px 0px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top:1px solid #979797;">
                                                                    </p>
                                                                    <p
                                                                            style="padding:0px 8px 0px 20px;font-size: 12px;line-height: 14px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                        <em> DP Charges </em></p>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <i>As applicable at actuals</i>
                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 30px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">

                                                                </td>
                                                                <td>
                                                                    <p
                                                                            style="padding:15px 8px 0px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top:1px solid #979797;">
                                                                    </p>
                                                                    <p
                                                                            style="padding:0px 8px 0px 20px;font-size: 12px;line-height: 14px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                        <em> Pledge Confirmation Charges </em></p>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <i>As applicable at actuals</i>
                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 30px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">

                                                                </td>
                                                                <td>
                                                                    <p
                                                                            style="padding:15px 8px 0px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top:1px solid #979797;">
                                                                    </p>
                                                                    <p
                                                                            style="padding:0px 8px 0px 20px;font-size: 12px;line-height: 14px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                        <em> Pledge Invocation Charges </em></p>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <i>As applicable at actuals</i>
                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 30px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">

                                                                </td>
                                                                <td>
                                                                    <p
                                                                            style="padding:8px 8px 0px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top:1px solid #979797;">
                                                                        <!-- Penal Interest - -->
                                                                    </p>
                                                                    <p
                                                                            style="padding:0px 8px 0px 20px;font-size: 12px;line-height: 14px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                        <em> Demat Share Transfer Charges (Post Invocation) </em></p>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <i>As applicable at actuals</i>
                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 30px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">

                                                                </td>
                                                                <td style="border-bottom:1px solid #979797;">
                                                                    <p
                                                                            style="padding:15px 8px 0px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top:1px solid #979797;">
                                                                        <!-- Penal Interest - -->
                                                                    </p>
                                                                    <p
                                                                            style="padding:0px 8px 0px 20px;font-size: 12px;line-height: 14px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                        <em> Legal Charges </em></p>
                                                                </td>
                                                                <td align="center"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                    <i>As applicable at actuals</i>
                                                                </td>
                                                            </tr>






                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">
                                                                    15
                                                                </td>
                                                                <td colspan="3" style="border-right:1px solid #979797;">
                                                                    <p
                                                                            style="padding:8px 8px 0px 4px;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top:0px solid #979797;">
                                                                        <b>Other Disclosures</b>
                                                                    </p>
                                                                </td>
                                                            </tr>


                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">
                                                                    a
                                                                </td>
                                                                <td
                                                                        style="padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top:1px solid #979797;border-top:1px solid #979797; border-bottom: 1px solid #979797; border-right: 1px solid #979797;"
                                                                        colspan="3">
                                                                    <div style="display: block"><strong>Cooling off/look-up period during which
                                                                        borrower shall not be charged any penalty
                                                                        on prepayment of loan<sup>(2)</sup> :</strong></div>

                                                                    <div style="display: block; height: 4px;"></div>

                                                                    <div style="display: block">3 days from the date of disbursal.
                                                                        For cancellation of your loan, you can call us on 8698010101 or write to us at
                                                                        Las.crm@bajajfinserv.in </div>

                                                                </td>
                                                            </tr>

                                                            <tr>
                                                                <td align="top" valign="middle"
                                                                    style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;border-bottom:none !important;">
                                                                    b
                                                                </td>
                                                                <td colspan="3"
                                                                    style="padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align:  middle; border-right:1px solid #979797; border-top:1px solid #979797;border-top:1px solid #979797; border-bottom: 1px solid #979797;">

                                                                    <div style="display: block"><strong> Details of Lending Service Provider acting as
                                                                        recovery agent and authorized to
                                                                        approach the borrower :</strong></div>

                                                                    <div style="display: block; height: 4px;"></div>

                                                                    <div style="display: block">
                                                                        LSP is not acting as recovery agent.<br>
                                                                        The details of the recovery agent authorized to collect on behalf of Bajaj
                                                                        Finance Ltd. will be intimated to you at the time of recovery collection. List
                                                                        of authorised associates empanelled for handling collections are updated on the
                                                                        BFL's website for reference. <br>
                                                                        <a
                                                                                href="http://www.bajajfinserv.in/active-partners-for-debt-management-services"
                                                                                style="color: #448aff !important;"
                                                                                target="_blank"
                                                                        >http://www.bajajfinserv.in/active-partners-for-debt-management-services</a>
                                                                    </div>

                                                                </td>

                                                            </tr>

                                                            <tr>
                                                                <td align="top" valign="top"
                                                                    style="border:1px solid #979797;padding:0px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;">
                                                                    c1
                                                                </td>
                                                                <td colspan="3"
                                                                    style="border-bottom:1px solid #979797; padding: 0px 0px 0px 4px; border-right:1px solid #979797;">

                                                                    <div style="display: block; height: 10px;"></div>

                                                                    <div style="display: block"><strong> Name, designation, address, phone number and
                                                                        email id of Nodal Grievance Redressal Officer of lender:</strong></div>

                                                                    <div style="display: block; height: 0px;"></div>

                                                                    <div style="display: block">
                                                                        Name: Manish Bhargav <br>
                                                                        Designation: Chief Operations Officer <br>
                                                                        Address: Bajaj Finserv Corporate Office, Viman Nagar, Pune, Maharashtra -
                                                                        411014<br>
                                                                        Phone number: 022-41803901<br>
                                                                        Email:grievanceredressalteam@bajajfinserv.in
                                                                        <!-- <a
                                                                        href="https://www.bajajfinserv.in/grievance-redressal">https://www.bajajfinserv.in/grievance-redressal</a> -->

                                                                    </div>

                                                                    <div style="display: block; height: 10px;"></div>

                                                                </td>


                                                            </tr>

                                                            <tr>
                                                                <td align="top" valign="top"
                                                                    style="border:1px solid #979797;padding:0px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;">
                                                                    c2
                                                                </td>
                                                                <td colspan="3"
                                                                    style="border-bottom:1px solid #979797; padding: 0px 0px 0px 4px; border-right:1px solid #979797;">

                                                                    <div style="display: block; height: 10px;"></div>

                                                                    <div style="display: block"><strong>Name, designation, address, phone number and email id of Nodal Grievance Redressal Officer of lender service provider:</strong></div>

                                                                    <div style="display: block; height: 0px;"></div>

                                                                    <div style="display: block">
                                                                        Name: ${kfsParameters.LSP_GrievanceOfficerName} <br>
                                                                        Designation: ${kfsParameters.LSP_GrievanceOfficerDesignation} <br>
                                                                        Address: ${kfsParameters.LSP_GrievanceOfficerAddress}<br>
                                                                        Phone number: ${kfsParameters.LSP_GrievanceOfficerPhone}<br>
                                                                        Email:${kfsParameters.LSP_GrievanceOfficerEmail}
                                                                        <!-- <a
                                                                        href="https://www.bajajfinserv.in/grievance-redressal">https://www.bajajfinserv.in/grievance-redressal</a> -->

                                                                    </div>

                                                                    <div style="display: block; height: 10px;"></div>

                                                                </td>


                                                            </tr>


                                                            <!--<tr>
                                                              <td align="top" valign="middle"
                                                                style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;">
                                                                c2
                                                              </td>
                                                              <td>
                                                                <p
                                                                  style="padding:8px 8px 8px 20px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;border-top:0px solid #979797;">
                                                                  Nodal Grievance Redressal Officer of lending service provider :
                                                              </td>
                                                              <td
                                                                style="border:1px solid #979797;padding:8px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;">
                                                                Name:<br>
                                                                Designation: <br>
                                                                Address:<br>
                                                                Phone number: <br>
                                                                Email:
                                                                 <a
                                                                  href="https://www.bajajfinserv.in/grievance-redressal">https://www.bajajfinserv.in/grievance-redressal</a>
                                                              </td>
                                                            </tr>-->

                                                            <tr>
                                                                <td align="top" valign="top"
                                                                    style="border:1px solid #979797;padding:0px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;">
                                                                    d1
                                                                </td>
                                                                <td colspan="3"
                                                                    style="border-bottom:1px solid #979797; padding: 0px 0px 0px 4px; border-right:1px solid #979797;">

                                                                    <div style="display: block; height: 10px;"></div>

                                                                    <div style="display: block">
                                                                        <strong>Privacy policy covering scope and type of information collected by the
                                                                            lender: </strong>
                                                                    </div>

                                                                    <div style="display: block; height: 4px;"></div>

                                                                    <div style="display: block"><a
                                                                            target="_blank"
                                                                            href="https://cms-assets.bajajfinserv.in/is/content/bajajfinance/privacy-policy-finalpdf?scl=1&fmt=pdf"
                                                                            style="color: #448aff !important;">
                                                                        BFL's Privacy Policy</a></div>

                                                                    <div style="display: block; height: 10px;"></div>

                                                                </td>


                                                            </tr>


                                                             <tr>
                                                                <td align="top" valign="top"
                                                                    style="border:1px solid #979797;padding:0px 8px 8px 4px;font-weight: 400;font-size: 12px;font-family: arial;line-height: 15px;letter-spacing: 0.0888889px;color: #000000;vertical-align: middle;text-align: center;">
                                                                    d2
                                                                </td>
                                                                <td colspan="3"
                                                                    style="border-bottom:1px solid #979797; padding: 0px 0px 0px 4px; border-right:1px solid #979797;">

                                                                    <div style="display: block; height: 10px;"></div>

                                                                    <div style="display: block">
                                                                        <strong>Privacy policy covering scope and type of information collected by the lender service provider:
                                                                        </strong>
                                                                    </div>

                                                                    <div style="display: block; height: 4px;"></div>

                                                                    <div style="display: block"><a
                                                                            target="_blank"
                                                                            href="https://voltmoney.in/privacy""
                                                                            style="color: #448aff !important;">
                                                                        LSP's Privacy Policy</a></div>

                                                                    <div style="display: block; height: 10px;"></div>

                                                                </td>


                                                            </tr>
                                                            </tr>
                                                            </tbody>
                                                            </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                </table>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>

            <tr>
                <td height="16">
                </td>
            </tr>
            </table>
            <!--[if (gte mso 9)|(IE)]></td></tr></table><![endif]-->
            </td>
            </tr>
            <br>

            <br>


            <div class="page-break-2">

            </div>

            <div class="box-wrapper">
                <div class="box-head">Repayment Schedule <sup>(3)</sup></div>
                <div class="box-body">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                            <tr>
                                <th style="text-align: center;" scope="col">Instl No.</th>
                                <!-- //<th style="text-align: center;" scope="col">Due Date</th> -->
                                <th style="text-align: center;" scope="col">Opening Principal</th>
                                <th style="text-align: center;" scope="col">Instl Amt</th>
                                <th style="text-align: center;" scope="col">Principal</th>
                                <th style="text-align: center;" scope="col">Interest</th>

                                <th style="text-align: center;" scope="col">Closing Principal</th>
                            </tr>
                            </thead>
                            <tbody>
                            ${renderRepaymentDate()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <p>(1) Actual interest calculation would change based on days gap between date of loan disbursement and first
                due date of instalment basis below scenario: </p>
            <p style="padding: 0px 0px 0px 10px;"><em>i) Scenario 1 - if gap is more than 30 days then Broken Period
                Interest / Pre-instalment Interest would be deducted from amount finance or added to the first instalment
                amount. </em></p>
            <p style="padding: 0px 0px 0px 10px;"><em>ii) Scenario 2 - if gap is less than 30 days then interest of the
                first instalment will be charged for actual number of gap days. </em></p>

            <p>(2) BFL provides an explicit option to the borrower to exit loan within the Cooling off/Look-up period, by
                repaying the principal amount and the proportionate Annual Percentage Rate (APR) without any penalty during
                the said period. Stamp duty, GST and other statutory charges/ taxes levied/ collected will not be refunded.
            </p>

            <p>(3) The repayment schedule is for illustrative purpose. There might be a difference in the actual repayment
                amount due to rounding off the instalment amount vis-à-vis the instalment amount mentioned in the Key Fact
                Statement. </p>


        </div>
    </div>



</div>

<script src="https://docapp.bajajfinserv.in/DocumentPOD_Lib/UI_Resource/Agreement/js/jquery.min.js"></script>
<script src="https://docapp.bajajfinserv.in/DocumentPOD_Lib/UI_Resource/Agreement/js/bootstrap.min.js"></script>
<script src="https://docapp.bajajfinserv.in/DocumentPOD_Lib/UI_Resource/Agreement/js/Custom.js"></script>

</body>

</html>
				`,
            }, javaScriptEnabled: true, domStorageEnabled: true, 
            // onNavigationStateChange={(event) =>
            // {
            // 	console.log("event 123: ", event)
            // }}
            // onShouldStartLoadWithRequest={handleShouldStartLoadWithRequest}
            // onMessage={handleWebViewMessage}
            automaticallyAdjustContentInsets: false, useWebKit: true, allowsInlineMediaPlayback: true, mediaPlaybackRequiresUserAction: false, javaScriptEnabledAndroid: true, showsHorizontalScrollIndicator: false, nestedScrollEnabled: Platform.OS !== "web", scalesPageToFit: false, scrollEnabled: Platform.OS === "ios", injectedJavaScript: `
				  $('form:first').css('max-width', '100%');
				  $('form:first').css('width', '100%');
				  $('div:first').removeClass("wrapper");
				  $('form:first').css('position', 'unset');
				  $('form:first').css('padding-bottom', '100%');
				  $('body').scrollTop({0});` }));
    };
    const _bodyChild = () => {
        return (React.createElement(ScrollView, { style: {
                height: '100%',
                flex: 1,
                paddingBottom: isIos() ? 150 : 100,
            }, nestedScrollEnabled: true, showsVerticalScrollIndicator: false }, KFS_WebView_New()));
    };
    return Platform.OS === 'web' ? (React.createElement(View, { style: [styles.container, { height: height }] },
        React.createElement(View, { style: styles.headerStyle }, _headerChild),
        React.createElement(ScrollView, { style: [styles.body, { height: height - 75 }], nestedScrollEnabled: true, scrollEnabled: true }, _bodyChild()),
        React.createElement(View, { style: styles.bottomContainer },
            React.createElement(Button, { id: 'bt_BajajKFS_continue', type: ButtonTypeTokens.LargeFilled, label: 'I agree', fontSize: FontSizeTokens.SM, loading: isButtonLoading, width: ButtonWidthTypeToken.FULL, onPress: () => {
                    if (agreeAction) {
                        if (!isButtonLoading) {
                            triggerAction(agreeAction);
                            setButtonLoading(true);
                        }
                    }
                } }),
            React.createElement(TouchableOpacity, { style: {
                    width: '100%',
                    marginTop: 16,
                    alignContent: 'center',
                    alignItems: 'center',
                }, onPress: () => {
                    setWarningCard(true);
                } },
                React.createElement(Typography, { id: 'bt_BajajKFS_disagree', label: 'I disagree', typeDLS: TypographyTypeDLS.B1B, color: ColorTokens.Primary_100 }))),
        kycStatusCard())) : (React.createElement(View, { style: [
            styles.container,
            { height: Platform.OS === "ios" ? height - 30 : height - 10 },
        ] },
        React.createElement(View, { style: {
                flex: 1,
            } },
            React.createElement(View, { style: styles.headerStyle }, _headerChild),
            React.createElement(ScrollView, { style: [
                    styles.body,
                    { height: height - 100 },
                ], nestedScrollEnabled: true, scrollEnabled: true }, _bodyChild()),
            React.createElement(View, { style: styles.bottomContainer },
                React.createElement(Button, { id: 'bt_BajajKFS_continue', type: ButtonTypeTokens.LargeFilled, label: 'I agree', fontSize: FontSizeTokens.SM, loading: isButtonLoading, width: ButtonWidthTypeToken.FULL, onPress: () => {
                        if (agreeAction) {
                            if (!isButtonLoading) {
                                triggerAction(agreeAction);
                                setButtonLoading(true);
                            }
                        }
                    } }),
                React.createElement(TouchableOpacity, { style: {
                        width: '100%',
                        marginTop: 16,
                        alignContent: 'center',
                        alignItems: 'center',
                    }, onPress: () => {
                        setWarningCard(true);
                    } },
                    React.createElement(Typography, { id: 'bt_BajajKFS_disagree', label: 'I disagree', typeDLS: TypographyTypeDLS.B1B, color: ColorTokens.Primary_100 })))),
        (showSuccessCard || warningCard) &&
            kycStatusCard()));
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        marginHorizontal: -16,
    },
    headerStyle: {
        ...(Platform.OS === 'ios' && {
            marginTop: 8,
        }),
    },
    body: {
        backgroundColor: '#F3F5FC',
        paddingBottom: 16,
    },
    footer: {
        position: 'absolute',
        bottom: '0',
        zIndex: 99,
        width: '100%',
        backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#F1F3F5',
        shadowColor: '#D0D5DD',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.25,
        shadowRadius: 6,
        elevation: 2,
    },
    groupContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    transactionCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    transactionLeftCardContainer: {
        flex: 3,
        display: 'flex',
        flexDirection: 'row',
    },
    transactionRightCardContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
    },
    tableContainer: {
        paddingTop: 30,
        backgroundColor: '#fff',
    },
    tableHead: {
        height: 40,
        backgroundColor: '#F9FAFB',
    },
    tableText: {
        textAlign: 'left',
        fontWeight: '400',
        fontSize: 12,
        lineHeight: 18,
        paddingVertical: 12,
        paddingHorizontal: 12,
    },
    tableHeadText: {
        textAlign: 'left',
        fontWeight: '400',
        fontSize: 12,
        lineHeight: 18,
        color: '#667085',
        padding: 12,
    },
    tableDataWrapper: { marginTop: -1 },
    tableRow: {},
    bottomContainer: {
        position: 'absolute',
        bottom: 0,
        padding: 16,
        marginTop: 5,
        width: '100%',
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        borderColor: '#F2F4F7',
        borderTopWidth: 1,
        paddingVertical: 16,
        shadowOpacity: 0.08,
        elevation: 10,
        backgroundColor: 'white',
    },
    successLottie: { width: 80, height: 'auto' },
});
export default BajajKFS;
